"use strict";

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _icons = require("@material-ui/icons");
var _CheckboxStyle = _interopRequireDefault(require("./CheckboxStyle"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-indent */
/* eslint-disable object-curly-newline */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-one-expression-per-line */

var alignment = 'flex-start';
var CheckBoxView = function CheckBoxView(_ref) {
  var _ref4;
  var classes = _ref.classes,
    checkboxItem = _ref.checkboxItem,
    datafield = _ref.datafield,
    onToggle = _ref.onToggle,
    facet = _ref.facet;
  var name = checkboxItem.name,
    subjects = checkboxItem.subjects,
    _checkboxItem$isCheck = checkboxItem.isChecked,
    isChecked = _checkboxItem$isCheck === void 0 ? false : _checkboxItem$isCheck,
    index = checkboxItem.index,
    section = checkboxItem.section,
    tooltip = checkboxItem.tooltip,
    label = checkboxItem.label;
  var indexType = index % 2 === 0 ? 'Even' : 'Odd';
  var checkedSection = "".concat(section).toLowerCase().replace(' ', '_');
  var handleToggle = function handleToggle() {
    var toggleCheckBoxItem = {
      name: name,
      datafield: datafield,
      isChecked: !isChecked
    };
    onToggle(toggleCheckBoxItem);
  };
  var LabelComponent = function LabelComponent() {
    var _ref2;
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      component: "div",
      className: (0, _clsx.default)(classes.panelDetailText, (_ref2 = {}, _defineProperty(_ref2, "".concat(checkedSection, "NameUnChecked"), !isChecked), _defineProperty(_ref2, "".concat(checkedSection, "NameChecked"), isChecked), _ref2))
    }, label ? /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.checkboxLabel
    }, label) : /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.checkboxName
    }, name));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    width: 1,
    button: true,
    alignItems: "flex-start",
    onClick: handleToggle,
    classes: {
      gutters: classes.listItemGutters
    },
    className: (0, _clsx.default)(_defineProperty({}, "".concat(checkedSection, "Checked").concat(indexType), isChecked))
  }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
    id: "checkbox_".concat(facet.label, "_").concat(name),
    icon: /*#__PURE__*/_react.default.createElement(_icons.CheckBoxOutlineBlank, {
      style: {
        fontSize: 18
      }
    }),
    onClick: handleToggle,
    checked: isChecked,
    checkedIcon: /*#__PURE__*/_react.default.createElement(_icons.CheckBox, {
      style: {
        fontSize: 18
      },
      className: "".concat(checkedSection, "CheckedIcon")
    }),
    disableRipple: true,
    color: "secondary",
    classes: {
      root: classes.checkboxRoot
    }
  }), tooltip ? /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    id: datafield,
    title: tooltip
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: datafield
  }, /*#__PURE__*/_react.default.createElement(LabelComponent, null))) : /*#__PURE__*/_react.default.createElement(LabelComponent, null), /*#__PURE__*/_react.default.createElement(_core.ListItemText, null), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: (0, _clsx.default)("".concat(checkedSection, "Subjects"), (_ref4 = {}, _defineProperty(_ref4, "".concat(checkedSection, "SubjectUnChecked"), !isChecked), _defineProperty(_ref4, "".concat(checkedSection, "SubjectChecked"), isChecked), _ref4))
  }, "(".concat(subjects, ")"))), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    style: {
      backgroundColor: isChecked ? '#FFFFFF' : '#b1b1b1',
      margin: '0px',
      height: isChecked ? '2px' : '1px'
    }
  }));
};
var _default = (0, _styles.withStyles)(_CheckboxStyle.default)(CheckBoxView);
exports.default = _default;